import React from "react";
import ProjectLists from "../DashboardProject/ProjectLists";
import { ProjectStatuses } from "../../constants/Status";

const PendingProjectListDashboard = () => {
  // document.title="Vector Maps | Velzon - React Admin & Dashboard Template";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <ProjectLists status={[ProjectStatuses.DRAFT, ProjectStatuses.IN_APPROVAL, ProjectStatuses.REJECTED]}/>
      </div>
    </div>
  );
};

export default PendingProjectListDashboard;
